module.exports = "<ion-item>\r\n  A Scene is a page within the project where learner interactions occur.\r\n</ion-item>"